/*
 * Copyright (c) 2025 by PROS, Inc.  All Rights Reserved.
 * This software is the confidential and proprietary information of
 * PROS, Inc. ("Confidential Information").
 * You may not disclose such Confidential Information, and may only
 * use such Confidential Information in accordance with the terms of
 * the license agreement you entered into with PROS.
 */
/**
 * Execute the given callback on 'Enter' keypress event.
 *
 * @param event the keyboard event.
 * @param cb a callback.
 */
export function withEnterKey(event, cb) {
    if (event.key === 'Enter') {
        cb();
    }
}
//# sourceMappingURL=with-enter-key.js.map